/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChallengeChallengeIdV2200ResponseAllOf
 */
export interface GetChallengeChallengeIdV2200ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeIdV2200ResponseAllOf
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeIdV2200ResponseAllOf interface.
 */
export function instanceOfGetChallengeChallengeIdV2200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetChallengeChallengeIdV2200ResponseAllOfFromJSON(json: any): GetChallengeChallengeIdV2200ResponseAllOf {
    return GetChallengeChallengeIdV2200ResponseAllOfFromJSONTyped(json, false);
}

export function GetChallengeChallengeIdV2200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeIdV2200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetChallengeChallengeIdV2200ResponseAllOfToJSON(value?: GetChallengeChallengeIdV2200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

